import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type {
	Expand,
	OrderBy,
} from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';
import type { CategoryId } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const BROWSE_KNOWLEDGE = 'state.actions.browse-knowledge.BROWSE_KNOWLEDGE' as const;

export type BrowseKnowledgePayload = {
	id: CategoryId;
	page: number;
	expand?: Expand[];
	orderBy?: OrderBy;
	limit?: number;
	query?: string;
	spaceKey?: string[];
	cursor?: string;
	createAnalyticsEvent?: CreateUIAnalyticsEvent;
};

export type BrowseKnowledgeAction = {
	type: typeof BROWSE_KNOWLEDGE;
	payload: BrowseKnowledgePayload;
};

export const browseKnowledge = (payload: BrowseKnowledgePayload): BrowseKnowledgeAction => ({
	type: BROWSE_KNOWLEDGE,
	payload,
});
